export default "__VITE_ASSET__7XaT_vai__";